import RoutesMap from "../../route_control/RouteControl"
import {
    InstalledEquipmentList,
    StockList,
    AuditLogList,
} from "../../pages/report"

export const ReportImport = {
    RoutesMap,
    InstalledEquipmentList,
    StockList,
    AuditLogList,
}